import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { isLease } from 'bundles/backoffice/vouchers/helpers/listings';
import LeaseListing from './lease_listing';
import SaleListing from './sale_listing';

export const ListingCard = ({ isParentDeal, listing }) => {
  if (isParentDeal) return null;

  return isLease({ listing }, { strict: true }) ? (
    <LeaseListing />
  ) : (
    <SaleListing listing={listing} />
  );
};

ListingCard.propTypes = {
  isParentDeal: PropTypes.bool,
  listing: PropTypes.shape({
    type: PropTypes.string.isRequired,
  })
};

const mapStateToProps = ({ deal }) => ({
  listing: deal.listing,
  isParentDeal: deal.parent
});

export default connect(mapStateToProps)(ListingCard);
